import { useToast } from '@/hooks/useToast';
import {
  useAddGiftsToExamConfig,
  useGetExamConfigs,
} from '@/api/hooks/useExamConfig';
import {
  AddGiftToExamConfigFormValues,
  useAddGiftToExamConfigForm,
} from '@/hooks/useAddGiftToExamConfig';

export const useAddGiftLogic = (onClose: () => void) => {
  const { showToast } = useToast();
  const { data: examConfigs } = useGetExamConfigs();
  const { register, handleSubmit, errors, reset } =
    useAddGiftToExamConfigForm();
  const { mutate: addGiftsToExamConfig } = useAddGiftsToExamConfig();

  const onSubmit = (data: AddGiftToExamConfigFormValues) => {
    if (!examConfigs || examConfigs.length === 0) {
      showToast("Aucune configuration d'examen disponible", 'error');
      return;
    }

    addGiftsToExamConfig(
      {
        examConfigId: examConfigs[0]._id,
        newGifts: [
          {
            name: data.name,
            ranking: data.ranking,
          },
        ],
      },
      {
        onSuccess: () => {
          reset();
          onClose();
          showToast('Cadeau ajouté avec succès', 'success');
        },
      },
    );
  };

  return {
    register,
    handleSubmit,
    errors,

    examConfigs,

    onSubmit,
  };
};
